import React from 'react';

import RadioButton from '../../Form/RadioButton/RadioButton';
import { Payload, QuestionType } from '../Types';
import QuestionButton from './QuestionButton';

interface Props {
    page: number;
    currentPage: number;
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
    payload: Payload;
    setPayload: React.Dispatch<React.SetStateAction<Payload>>;
    question: QuestionType;
}

const Question: React.FunctionComponent<Props> = (props) => {
    if (props.page !== props.currentPage) {
        return null;
    }

    const onFieldChange = (value: string) =>
        props.setPayload((payload) => ({ ...payload, [props.question.id]: value }));

    return (
        <div className="online-analysis__question">
            <header className="online-analysis__question-header">
                <h3>{props.question.label}</h3>
                <div className="online-analysis__navigation">
                    {props.currentPage > 1 ? (
                        <QuestionButton
                            disabled={props.page <= 1}
                            onClick={() => props.setCurrentPage((page) => page - 1)}
                            forward={false}
                        >
                            zurück
                        </QuestionButton>
                    ) : null}
                    <QuestionButton
                        disabled={props.page >= 5 || props.payload[props.question.id] === null}
                        onClick={() => props.setCurrentPage((page) => page + 1)}
                        forward={true}
                    >
                        Nächste Frage
                    </QuestionButton>
                </div>
            </header>

            <div className="online-analysis__answers">
                {props.question.answers.map((answer) => (
                    <RadioButton
                        key={answer.value}
                        name={props.question.id}
                        checked={props.payload[props.question.id] === answer.value}
                        onChange={() => onFieldChange(answer.value)}
                        value={answer.value}
                        label={answer.label}
                        infoText={answer.infoText}
                    />
                ))}
            </div>

            <div className="online-analysis__infobox">
                <h4>Gut zu wissen:</h4>
                <p>{props.question.infoText}</p>
            </div>
        </div>
    );
};

export default Question;
